import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "../me/index.js";
import { RueckfrageGastgeber } from "./VerwerfenRueckfrage.js";
import { StrikteEbene, useElternHuelle, useStrikteWege } from "./strikteHuelle.js";
/** Neben einem vollflächigen Dialog passt nichts — jeder Subdialog wird gestapelt. */
const VOLL_PX = Number.POSITIVE_INFINITY;
export function Arbeitsdialog(p) {
    const eltern = useElternHuelle();
    const { anker, steuerung } = useStrikteWege(p);
    /*
     * `unter="stapel"` fest: Liegt der Arbeitsdialog seinerseits über einem offenen Dialog,
     * kann ein vollflächiges Blatt nur darüber liegen, nie daneben.
     * `aria-label` = Titel wie beim `Modal` (Namensberechnung ohne Schatten-Verweis).
     */
    return (_jsx(StrikteEbene, { eltern: eltern, breitePx: VOLL_PX, children: _jsxs(Dialog, { ref: steuerung, offen: true, strikt: true, art: "arbeit", breite: "voll", unter: "stapel", className: "ki-arbeitsdialog", "aria-label": p.titel, titel: _jsx("span", { ref: anker, children: p.titel }), steckbrief: p.steckbrief, meldungen: p.meldungen, register: p.register, hinweis: p.hinweis, fussLinks: p.fussLinks, fuss: p.fuss, children: [p.children, _jsx(RueckfrageGastgeber, {})] }) }));
}
//# sourceMappingURL=Arbeitsdialog.js.map